<script>
	import { onMount } from "svelte";
	import Dropzone from "dropzone";

	export let id = "dropzone";
	export let message = "Drop files here or click to upload.";
	export let options = { previewTemplate: "<div/>" };
	export let dropzoneClass = "dropzone";
	export let hoveringClass = "dropzone-hovering";
	export let documentList = [];
	export let required = null;
	export let disabled = null;
	export let label = null;

	const search = /[\/\\?%*:|"<>]/g;
	const replace = "";

	let myDropzone;
	let uploadErrors = [];

	onMount(() => {
		if (!disabled) {
			Dropzone.autoDiscover = false;
			options.renameFile = function (file) {
				return file.name.replace(search, replace);
			};
			myDropzone = new Dropzone("div#" + id, options);

			myDropzone.on("addedfile", function (file) {
				if (file.size === 0) {
					myDropzone.removeFile(file);
					removeFromFileList(map(file));
					uploadErrors = [...uploadErrors, `File ${file.name} is empty with 0 bytes`];
				}

				file.previewElement.addEventListener("click", function () {
					processFileDeletion(file, true);
				});
			});

			myDropzone.on("success", function (file, projectDocumentId) {
				documentList.push(map(file, projectDocumentId));
				documentList = [...documentList];

				uploadErrors = []; // Reset the error message being displayed
			});

			myDropzone.on("complete", function (file) {
				// if (file.status === "success") {}
				repopulateFilePreview();
			});

			myDropzone.on("error", function (file, response) {
				myDropzone.removeFile(file);
				removeFromFileList(map(file));
				uploadErrors = [...uploadErrors, `${response}`];
			});

			repopulateFilePreview();
		}
	});

	$: if (myDropzone && myDropzone.options.url != options.url) {
		myDropzone.options.url = options.url;
		repopulateFilePreview();
	}

	function map(file, projectDocumentId = null) {
		return {
			fileName: file.upload.filename,
			fileSize: formatFileSize(file.size),
			uuid: file.upload.uuid,
			id: "i" + file.upload.uuid.substring(0, 7),
			projectDocumentId: projectDocumentId
		};
	}

	function removeFromFileList(file) {
		for (var i = 0; i < documentList.length; i++) {
			if (documentList[i].uuid == file.uuid) {
				documentList.splice(i, 1);
				documentList = [...documentList];
				break;
			}
		}

		let dropzones = document.querySelectorAll("." + dropzoneClass);
		if (dropzones.length) {
			if (documentList.length == 0) {
				dropzones[0].classList.remove("dz-started");
			} else {
				dropzones[0].classList.add("dz-started");
			}
		}

		var fileElement = document.querySelector("#" + file.id);
		fileElement && fileElement.parentNode.removeChild(fileElement);
	}

	function buildFilePreviewNode(file) {
		let html = `<div id="${file.id}" class="dz-preview dz-file-preview dz-processing dz-success dz-complete" title="Click to delete">
    <div class="dz-image"><img data-dz-thumbnail=""></div>
    <div class="dz-details">
        <div class="dz-size">
            <span data-dz-size="">${file.fileSize}</span>
        </div>
        <div class="dz-filename">
            <span data-dz-name="">${file.fileName}</span>
        </div>
    </div>
    <div class='deleteWrapper'><i class="fa fa-times"></i></div>
</div>`;

		let template = document.createElement("template");
		template.innerHTML = html;
		return template.content.childNodes[0];
	}

	function repopulateFilePreview() {
		let fileNodes = document.querySelectorAll("." + dropzoneClass + " .dz-preview");
		let dropzones = document.querySelectorAll("." + dropzoneClass);
		let dropzone;

		if (dropzones === null) return;
		if (dropzones.length === 1) {
			dropzone = dropzones[0];
		} else {
			dropzones.forEach((d) => {
				if (d.id == id) dropzone = d;
			});
		}

		fileNodes.forEach((node) => {
			node.parentNode.removeChild(node);
		});

		if (documentList && documentList.length > 0) {
			dropzone.classList.add("dz-started");
			documentList.forEach((file) => {
				let preview = buildFilePreviewNode(file);

				preview.addEventListener("click", function () {
					processFileDeletion(file, false);
				});

				dropzone.appendChild(preview);
			});
		} else {
			dropzone.classList.remove("dz-started");
		}
	}

	function formatFileSize(size) {
		var selectedSize = 0;
		var selectedUnit = "b";

		if (size > 0) {
			var units = ["TB", "GB", "MB", "KB", "b"];

			for (var i = 0; i < units.length; i++) {
				var unit = units[i];
				var cutoff = Math.pow(1000, 4 - i) / 10;

				if (size >= cutoff) {
					selectedSize = size / Math.pow(1000, 4 - i);
					selectedUnit = unit;
					break;
				}
			}

			selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
		}

		return "<strong>".concat(selectedSize, "</strong> ").concat(selectedUnit);
	}

	const processFileDeletion = async (file, isMappingRequired = false) => {
		let response = await deleteFileUpload(file.projectDocumentId);
		if (response.success) {
			myDropzone.removeFile(file);
			if (isMappingRequired) {
				removeFromFileList(map(file));
			} else {
				removeFromFileList(file);
			}
		} else {
			alert(response.message);
		}
	};

	const deleteFileUpload = async (projectDocumentId) => {
		try {
			if (!projectDocumentId) {
				return { success: false, message: "Error: Missing required params" };
			}

			let url = `${options.url}&projectDocumentId=${projectDocumentId}`;
			let headers = { "Content-type": "application/json; charset=utf-8" };

			const method = "DELETE";
			let data = null;

			const response = await fetch(url, {
				method,
				headers,
				body: data
			});

			if (response.ok) {
				// If successful
				return { success: true, message: null };
			} else {
				// If failed
				if (response) {
					let response = JSON.parse(response);
					return { success: false, message: response.errorMessage };
				} else {
					return { success: false, message: "Error: File Upload Deletion" };
				}
			}
		} catch (err) {
			console.error("Unexpected result:", err);
			if (err.response) {
				let response = JSON.parse(err.response);
				return { success: false, message: response.errorMessage };
			} else {
				return { success: false, message: "Error: File Upload Deletion" };
			}
		}
	};
</script>

{#if !disabled}
	<div class="form-row">
		{#if label}<div>{label}</div>{/if}
		<div class="form-group col-md-12">
			<div class={dropzoneClass} {id}>
				<slot>
					<div class="dz-message needsclick">
						<button type="button" class="dz-button">{@html message}</button><br />
					</div>
				</slot>
			</div>
		</div>
		<div id="uploadError" class={uploadErrors.length ? "error-message" : ""}>
			{@html uploadErrors.length ? uploadErrors.join("<br/>") : ""}
		</div>
		<input hidden {required} value={documentList.length > 0 ? "SUCCESS" : null} />
	</div>
{:else}
	<div class="form-row">
		{#if documentList && documentList.length}
			<div class="col">
				<h4>Uploaded Documents</h4>
			</div>

			{#each documentList as document, i}
				<div class="form-group col-md-12">
					{document.fileName}
				</div>
			{/each}
		{:else}
			<div class="col">
				<h4>No files uploaded</h4>
			</div>
		{/if}
	</div>
{/if}

<style>
	:global(.deleteWrapper) {
		position: absolute;
		top: -8px;
		right: -8px;
		border-radius: 40px;
		border: 1px solid #e46937;
		height: 35px;
		width: 35px;
		z-index: 100;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #e46937;
		color: white;
		text-align: center;
		padding-left: 2px;
	}

	:global(.dropzone.dz-clickable .deleteWrapper, .dropzone.dz-clickable .deleteWrapper *) {
		cursor: pointer;
	}
</style>
